import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { saveSingle } from "../../services/paidChequeService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import { Table } from "semantic-ui-react";
import TableTitle from "../common/tableTitle";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getEntrySubTypes } from "../../services/generalLedgerService";

class PaidChequeForm extends Form {
  state = {
    invoiceDate: new Date(),
    imageUrl: false,
    cheque_types: [
      { id: "", name: "Select option" },
      { id: "debit", name: "Debit" },
      { id: "credit", name: "Credit" },
    ],
    data: {
      client: "",
      mobile_no: "",
      description: "",
      amount: "",
      project: "",
      other: "",
      cheque_type: "",
    },
    projects: [],
    others: [],
    errors: {},
  };

  async componentDidMount() {
    this.setState({ blocking: true });
    let params = {
      company: 1,
      entryType: "project",
    };
    const { data: res } = await getEntrySubTypes(params);
    this.setState({
      blocking: false,
      projects: res.accounts,
    });

    params = {
      company: 1,
      entryType: "account",
    };
    const { data: res1 } = await getEntrySubTypes(params);
    this.setState({
      blocking: false,
      others: res1.accounts,
    });
  }

  schema = {
    id: Joi.string(),
    client: Joi.string().required().label("Client"),
    mobile_no: Joi.string().required().label("Mobile"),
    description: Joi.string().required().label("Description"),
    amount: Joi.number().required().label("Amount"),
    project: Joi.number().allow(""),
    other: Joi.number().allow(""),
    cheque_type: Joi.string().required(),
  };

  handleChangeInvoice = (date) => {
    this.setState({
      invoiceDate: date,
    });
  };

  doSubmit = async () => {
    try {
      if (this.state.data.other == "" && this.state.data.project == "") {
        toast.warning("Please select project or account to continue!");
        return false;
      }

      if (this.state.data.other != "" && this.state.data.project != "") {
        toast.warning(
          "Please select only one, account or project to continue!"
        );
        return false;
      }

      this.setState({ blocking: true });

      let formData = new FormData();

      var event = new Date(this.state.invoiceDate);
      let date = JSON.stringify(event);
      date = date.slice(1, 11);

      formData.append("date", date);
      formData.append("client", this.state.data.client);
      formData.append("mobile_no", this.state.data.mobile_no);
      formData.append("description", this.state.data.description);
      formData.append("amount", this.state.data.amount);
      formData.append("attachment", this.state.imageUrl);
      formData.append("account_id", this.state.data.other);
      formData.append("project_id", this.state.data.project);
      formData.append("cheque_type", this.state.data.cheque_type);

      await saveSingle(formData);
      toast.success("Entry has been added successfully.");
      this.setState({ blocking: false });
      this.props.history.push("/pdc-cheques/paid");
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.passport_number)
          errors.passport_number = ex.response.data.errors.passport_number;

        if (ex.response.data.errors.identification_id)
          errors.identification_id = ex.response.data.errors.identification_id;

        if (ex.response.data.errors.mobile)
          errors.mobile = ex.response.data.errors.mobile;

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        this.setState({ errors, blocking: false });
        //toast.warning("check validation errors.");
      }
    }
  };

  onChangeFile = (e) => {
    let files = e.target.files || e.dataTransfer.files;
    if (!files.length) return;
    this.setState({ imageUrl: files[0] });
    //this.createImage(files[0]);
  };

  render() {
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Add Entry</h1>
        <button
          className="btn btn--secondary"
          onClick={() => this.props.history.push("/pdc-cheques/paid")}
        >
          Back
        </button>
        <form onSubmit={this.handleSubmit}>
          <div className="card form">
            <div className="form__content">
              <h3 className="card__heading">Add Entry</h3>
              <p>Provide the information below to add the entry.</p>
              <label>Date</label>
              <DatePicker
                selected={this.state.invoiceDate}
                onChange={this.handleChangeInvoice}
                className="input"
              />
              {this.renderInput("client", "Client", "text")}
              {this.renderInput("mobile_no", "Mobile", "text")}
              {this.renderInput("description", "Description", "text")}
              {this.renderInput("amount", "Amount", "text")}
              <label>Attachment</label>
              <input
                className="input"
                type="file"
                onChange={this.onChangeFile}
              />
              {this.renderSelect("project", "Project", this.state.projects)}
              {this.renderSelect("other", "Other Account", this.state.others)}
              {this.renderSelect(
                "cheque_type",
                "Cheque Type",
                this.state.cheque_types
              )}

              {this.renderButton("Save")}
            </div>
          </div>
        </form>
      </BlockUi>
    );
  }
}

export default PaidChequeForm;
